import img1 from "../../images/filter-img/1.png";
import img2 from "../../images/filter-img/2.png";
import img3 from "../../images/filter-img/3.png";
import img4 from "../../images/filter-img/4.png";
import img5 from "../../images/filter-img/5.png";
import img6 from "../../images/filter-img/6.png";
import img7 from "../../images/filter-img/7.png";
import img8 from "../../images/filter-img/8.png";
import img9 from "../../images/filter-img/9.png";
import img10 from "../../images/filter-img/10.png";
import img11 from "../../images/filter-img/11.png";

const filters = [
  {
    img: img1,
    title: "Ko‘chmas mulk",
    info1: "Xususiy uylar",
    info2: "Kvartiralar",
    info3: "Yer uchastkasi",
    info4: "Tijorat binolari",
    info5: "Garajlar / turargohlar",
    num1: "(592,268)",
    num2: "(121,652)",
    num3: "(199,047)",
    num4: "(602)",
    num5: "(10,962)",
  },
  {
    img: img2,
    title: "Transport",
    info1: "Xususiy uylar",
    info2: "Kvartiralar",
    info3: "Yer uchastkasi",
    info4: "Tijorat binolari",
    info5: "Garajlar / turargohlar",
    num1: "(592,268)",
    num2: "(121,652)",
    num3: "(199,047)",
    num4: "(602)",
    num5: "(10,962)",
  },
  {
    img: img3,
    title: "Ish",
    info1: "Xususiy uylar",
    info2: "Kvartiralar",
    info3: "Yer uchastkasi",
    info4: "Tijorat binolari",
    info5: "Garajlar / turargohlar",
    num1: "(592,268)",
    num2: "(121,652)",
    num3: "(199,047)",
    num4: "(602)",
    num5: "(10,962)",
  },
  {
    img: img4,
    title: "Xizmatlar",
    info1: "Xususiy uylar",
    info2: "Kvartiralar",
    info3: "Yer uchastkasi",
    info4: "Tijorat binolari",
    info5: "Garajlar / turargohlar",
    num1: "(592,268)",
    num2: "(121,652)",
    num3: "(199,047)",
    num4: "(602)",
    num5: "(10,962)",
  },
  {
    img: img5,
    title: "Elektr jihozlari",
    info1: "Xususiy uylar",
    info2: "Kvartiralar",
    info3: "Yer uchastkasi",
    info4: "Tijorat binolari",
    info5: "Garajlar / turargohlar",
    num1: "(592,268)",
    num2: "(121,652)",
    num3: "(199,047)",
    num4: "(602)",
    num5: "(10,962)",
  },
  {
    img: img6,
    title: "Uy va bog’",
    info1: "Xususiy uylar",
    info2: "Kvartiralar",
    info3: "Yer uchastkasi",
    info4: "Tijorat binolari",
    info5: "Garajlar / turargohlar",
    num1: "(592,268)",
    num2: "(121,652)",
    num3: "(199,047)",
    num4: "(602)",
    num5: "(10,962)",
  },
  {
    img: img7,
    title: "Moda va Still",
    info1: "Xususiy uylar",
    info2: "Kvartiralar",
    info3: "Yer uchastkasi",
    info4: "Tijorat binolari",
    info5: "Garajlar / turargohlar",
    num1: "(592,268)",
    num2: "(121,652)",
    num3: "(199,047)",
    num4: "(602)",
    num5: "(10,962)",
  },
  {
    img: img8,
    title: "Bolalar dunyosi",
    info1: "Xususiy uylar",
    info2: "Kvartiralar",
    info3: "Yer uchastkasi",
    info4: "Tijorat binolari",
    info5: "Garajlar / turargohlar",
    num1: "(592,268)",
    num2: "(121,652)",
    num3: "(199,047)",
    num4: "(602)",
    num5: "(10,962)",
  },
  {
    img: img9,
    title: "Hayvonlar",
    info1: "Xususiy uylar",
    info2: "Kvartiralar",
    info3: "Yer uchastkasi",
    info4: "Tijorat binolari",
    info5: "Garajlar / turargohlar",
    num1: "(592,268)",
    num2: "(121,652)",
    num3: "(199,047)",
    num4: "(602)",
    num5: "(10,962)",
  },
  {
    img: img10,
    title: "Xobbi dam olish sport",
    info1: "Xususiy uylar",
    info2: "Kvartiralar",
    info3: "Yer uchastkasi",
    info4: "Tijorat binolari",
    info5: "Garajlar / turargohlar",
    num1: "(592,268)",
    num2: "(121,652)",
    num3: "(199,047)",
    num4: "(602)",
    num5: "(10,962)",
  },
  {
    img: img11,
    title: "Ayirboshlash",
    info1: "Xususiy uylar",
    info2: "Kvartiralar",
    info3: "Yer uchastkasi",
    info4: "Tijorat binolari",
    info5: "Garajlar / turargohlar",
    num1: "(592,268)",
    num2: "(121,652)",
    num3: "(199,047)",
    num4: "(602)",
    num5: "(10,962)",
  },
];

export default filters;
